import useAuthFormViewModel from './AuthFormViewModel'

import AuthForm from './AuthForm'

import './SignUp.css'

const SignUp = () => {
    
    const viewModel = useAuthFormViewModel()
    
    return (
        
        <div className="SignUp">
            
            <AuthForm
                viewModel={viewModel}
                onSubmit={viewModel.onSignUpSubmit}
                submitButtonText="Next"
                cancelButtonText="Cancel"
                cancelButtonLink="/signin">
                
                <input
                    className="input input-bordered w-full !input-md"
                    type="text"
                    name="firstName"
                    id="first-name"
                    onChange={e => viewModel.setFirstName(e.target.value)}
                    placeholder="First Name"/>
                
                <input
                    className="input input-bordered w-full !input-md mt-3"
                    type="text"
                    name="lastName"
                    id="last-name"
                    onChange={e => viewModel.setLastName(e.target.value)}
                    placeholder="Last Name"/>
                
                <input
                    className="input input-bordered w-full mt-3 mb-6"
                    type="email"
                    name="email"
                    id="email"
                    onChange={e => viewModel.setEmail(e.target.value)}
                    placeholder="example@email.com"/>
            
            </AuthForm>
        
        </div>
        
    )
}

export default SignUp
